import type { Item, ItemUI } from '@libs/common-node';
import { PharmacyType } from '@libs/core';

export const isProductRxMedItem = (product: ItemUI | Item): boolean => product.pharmacyType === PharmacyType.MED;

export const isProductRxFoodItem = (product: ItemUI | Item): boolean => product.pharmacyType === PharmacyType.FOOD;

export const isProductRxMedColdItem = (product: ItemUI | Item): boolean =>
    product.pharmacyType === PharmacyType.MED && product.coldItem === true;
